import React from 'react';
import PropTypes from 'prop-types';
import LineItem from '../line_item/LineItem';
import './LineItems.sass';

function LineItems(props) {
  const { lineItems, uneditable } = props;

  return (
    <div className="products-container">
      { lineItems && lineItems.map((lineItem) => (
        <LineItem key={lineItem.id} lineItem={lineItem} uneditable={uneditable} />
      ))}
    </div>
  );
}

LineItems.propTypes = {
  lineItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  uneditable: PropTypes.bool.isRequired,
};

export default LineItems;
